/**
 * BackgroundEffects - Subtle background decorations
 * 
 * Simplified to reduce animation overhead and prevent performance issues.
 * Uses CSS-only where possible for better performance.
 */

const BackgroundEffects = () => {
  return (
    <div 
      className="fixed inset-0 pointer-events-none overflow-hidden z-0"
      aria-hidden="true"
    >
      {/* Static gradient overlays - no JS animation needed */}
      <div className="absolute inset-0 bg-gradient-to-br from-primary-900/5 via-transparent to-primary-800/5" />
      <div className="absolute inset-0 bg-gradient-to-tl from-primary-700/3 via-transparent to-primary-600/3" />
      
      {/* Subtle animated glow using CSS */}
      <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-primary-500/5 rounded-full blur-3xl animate-pulse-slow" />
      <div className="absolute bottom-1/4 right-1/4 w-80 h-80 bg-primary-400/5 rounded-full blur-3xl animate-pulse-slower" />
      
      {/* Simple decorative lines */}
      <svg 
        className="absolute inset-0 w-full h-full opacity-[0.03]" 
        viewBox="0 0 100 100" 
        preserveAspectRatio="none"
      >
        <line x1="0" y1="30" x2="100" y2="25" stroke="currentColor" strokeWidth="0.1" className="text-primary-400" />
        <line x1="0" y1="60" x2="100" y2="65" stroke="currentColor" strokeWidth="0.1" className="text-primary-400" />
        <line x1="0" y1="85" x2="100" y2="80" stroke="currentColor" strokeWidth="0.1" className="text-primary-400" />
      </svg>
    </div>
  );
};

export default BackgroundEffects;
